export default __webpack_public_path__ + "static/media/BTT.80c63656.png";